/**
* @Author: Roxy Chen
* @Date:   2016-08-17T18:10:52+08:00
* @Last modified by:   Roxy Chen
* @Last modified time: 2016-08-22T19:43:21+08:00
* @License: Copyright (c) by Giftpack Inc. All Rights Reserved.
*/

import Waypoint from "react-waypoint";

// import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import React, { Component , PropTypes } from "react";
import { Link } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../../actions/global";

import AnimateEffect from "../../tool/animateEffect";

export default class ResetPWD extends Component {
  constructor(props) {
    super(props);
    this.state = {
      /*serviceWaypoint: false,
      landingWaypoint: false,
      numberTalksWayPoint: false,
      navFix: true*/
    };
  }
  componentDidMount(){}
  render() {

    return (
      <div className="main-container resetPWDPage loginSeries">
        <div className="blackCover"></div>
        <div className="wrapper">
          <h1 className="title">Rest<br />Password</h1>
          <div className="formArea">
            <form className="resetPWDForm">
              <div className="lastInput"><input type="email" placeholder="EMAIL" /></div>
            </form>
          </div>
          <div className="hint">
            <p>Do not have an account? <a href="./sign-up" className="hintLink">Sign Up</a></p>
            <p>Already have an account? <a href="./login" className="hintLink">Login</a></p>
          </div>
        </div>
      </div>
    );

  }
}





// export default connect((state , ownProps ) => ( state ))( Index );
